"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toErrorMessage = (error) => {
    if (!error) {
        return '';
    }
    if (error instanceof Error) {
        const { message } = error;
        return message;
    }
    if (typeof error === 'string') {
        return error;
    }
    if (typeof error === 'object') {
        return JSON.stringify(error);
    }
    return `${error}`;
};
exports.default = toErrorMessage;
//# sourceMappingURL=toErrorMessage.js.map